var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    {
      staticClass: "wizard-steps horizontal-steps simple-steps",
      class: { completed: _vm.completed },
    },
    [
      _vm._l(_vm.steps, function (step, index) {
        return _vm.steps
          ? _c(
              "li",
              {
                key: index,
                staticClass: "wizard-step",
                class: {
                  active: _vm.currentStep >= index,
                  current: _vm.currentStep === index,
                },
                style: { height: 100 / _vm.steps.length + "%" },
              },
              [
                _c("span", { staticClass: "wizard-step-line" }),
                _c("span", { staticClass: "wizard-step-line completed-line" }),
                _c("span", { staticClass: "wizard-step-label ellipsis" }, [
                  _vm._v(_vm._s(step.label)),
                ]),
                _c("span", { staticClass: "wizard-step-indicator" }),
              ]
            )
          : _vm._e()
      }),
      !_vm.steps
        ? _c(
            "li",
            {
              staticClass: "wizard-step",
              class: { active: _vm.isActive },
              style: { height: 100 + "%" },
            },
            [
              _c("span", { staticClass: "wizard-step-line" }),
              _c("span", { staticClass: "wizard-step-line completed-line" }),
              _c("span", { staticClass: "wizard-step-label ellipsis" }),
              _c("span", { staticClass: "wizard-step-indicator" }),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }